import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-bootstrap'
import { Link } from 'react-router'
import { includes, last, map } from 'lodash'
import classNames from 'classnames'
import * as css from './side-nav.scss'

class SideNav extends Component {
  static propTypes = {
    activeSlugSet: PropTypes.array,
    categoryTree: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            urlSlug: PropTypes.string,
            path: PropTypes.string,
            image: PropTypes.string,
          })
        ),
        path: PropTypes.string.isRequired,
        urlSlug: PropTypes.string.isRequired,
        image: PropTypes.string,
      })
    ).isRequired,
    renderInMobileNav: PropTypes.bool,
    maxDepth: PropTypes.number,
    navCategory: PropTypes.object,
    sidebarTitle: PropTypes.string.isRequired,
  }

  static defaultProps = {
    maxDepth: 3,
    renderInMobileNav: false,
  }

  render() {
    let activeSlugSet = this.props.activeSlugSet

    return (
      <div className="hidden-xs">
        <div className="h6 text-bold mbs">{this.props.sidebarTitle}</div>
        <hr style={{ maxWidth: 200 }} />
        <ul
          className={classNames('catalog-side-nav list-unstyled', {
            [css.catalogMobileNav]: this.props.renderInMobileNav,
          })}
        >
          {this.props.navCategory && (
            <CategoryWithChildren
              activeSlugSet={activeSlugSet}
              category={this.props.navCategory}
              parentSlugSet={[]}
            />
          )}
          {map(this.props.categoryTree, (category, idx) => (
            <CategoryWithChildren
              activeSlugSet={activeSlugSet}
              parentSlugSet={[]}
              category={category}
              key={category.urlSlug}
              maxDepth={this.props.maxDepth}
            />
          ))}
        </ul>
      </div>
    )
  }
}

const CategoryWithChildren = ({
  activeSlugSet,
  category,
  depth = 1,
  isChild,
  maxDepth,
  parentSlugSet,
}) => {
  const leafCategory =
    !category.children || category.children.length == 0 || depth == maxDepth

  const active = last(activeSlugSet) == category.urlSlug
  const open = !leafCategory && includes(activeSlugSet, category.urlSlug)
  const currentSlugSet = [...parentSlugSet, category.urlSlug]

  return (
    <li
      className={classNames(css.category, { [css.subCategory]: isChild })}
      key={category.title}
    >
      <Link
        className={classNames({ [css.active]: active })}
        to={{ pathname: category.path, state: { slugSet: currentSlugSet } }}
      >
        {category.title}
        {!leafCategory && depth > 1 ? (
          <span className="pls">
            <span
              className={classNames('fa fa-angle-right', css.chevron, {
                [css.activeChevron]: open,
              })}
            />
          </span>
        ) : null}
      </Link>
      {!leafCategory ? (
        <Collapse in={open}>
          <div>
            <ul className={classNames('list-unstyled pbs')}>
              {map(category.children, (cat, idx) => (
                <CategoryWithChildren
                  isChild
                  activeSlugSet={activeSlugSet}
                  category={cat}
                  depth={depth + 1}
                  key={cat.urlSlug}
                  maxDepth={maxDepth}
                  parentSlugSet={currentSlugSet}
                />
              ))}
            </ul>
          </div>
        </Collapse>
      ) : null}
    </li>
  )
}

export default SideNav
